import baseRequest from "../_core/baseRequest";

export default {
    /* groupName'in tanımlı olduğu optionları listeler */
    getOptionsByGroupName: ({groupName}) =>
        baseRequest.get(`form-options/pretty/${groupName || ""}`),
    /* belirtilen filtrelere uygun olan kayıtları getirir */
    getOptions: params => baseRequest.post(`form-options/pretty`, params)
};
